// import React, { useState, useEffect } from "react";
// import Paper from "@mui/material/Paper";
// // import Box from "@mui/material/Box";
// import { alpha, styled } from "@mui/material/styles";
// import { Button, TablePagination } from "@mui/material";
// // import TextField from "@mui/material/TextField";
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from "@mui/material/FormControl";
// // import Checkbox from '@mui/material/Checkbox';
// import moment from "moment";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { InputAdornment, IconButton } from '@mui/material';
// // import { Typography, Stack } from '@mui/material';
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import { Box, Typography, Autocomplete, TextField, Chip } from '@mui/material';
// import "./index.css";

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

// // const skills = [
// //   "Python",
// //   "Java",
// //   "Artificial Intelligence",
// //   "Data Science",
// //   "Automation Testing",
// //   "Devops",
// //   "React JS",
// //   "Node JS",
// //   "Scripiting languages",
// //   "Linux",
// // ];

// // const jobCodes = {
// //   "UPL001": "Associate Engineer",
// //   "UPL002": "Senior Engineer",
// //   "UPL003": "Technical Lead",
// //   "UPL004": "Senior Developer",
// // };

// const AddNewCandidate = () => {
//   const [name, setName] = useState("");
//   const [selectedJobID, setSelectedJobID] = useState("");
//   const [selectedJobDetails, setSelectedJobDetails] = useState({});
//   const [selectedSkills, setSelectedSkills] = useState([]);
//   const aiDishaApi = createInstance("DISHA");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [educationDetails, setEducationDetails] = useState([]);
//   const [educationDetailsUg, setEducationDetailsUg] = useState([]);
//   const [educationDetailsPg, setEducationDetailsPg] = useState([]);
//   const [yearsOfExpList, setYearsOfExpList] = useState([]);
//   const [monthsOfExpList, setMonthsOfExpList] = useState([]);
//   const [expYearsList, setExpYearsList] = useState([]);
//   const [selectedYear, setSelectedYear] = useState("");
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [candidate_full_name, setCandidate_full_name] = useState();
//   const [email_id, setEmail_id] = useState("");
//   const [skills, setSkills] = useState("");
//   const [ugDegree, setUgDegree] = useState("");
//   const [pgDegree, setPgDegree] = useState("");
//   const [isOthersUg, setIsOthersUg] = useState(false);
//   const [isOthersPg, setIsOthersPg] = useState(false);
//   const [jobIDs, setJobIDs] = useState([]);
//   const [alljobs, setAllJobs] = useState([]);
//   const [jobTitle, setJobTitle] = useState([]);
//   const [years, setYears] = useState([]);
//   const [resume, setResume] = useState(null);
//   const [error, setError] = useState('');
//   const [ActiveSkills, setActiveSkills] = useState([]);
//   const [requiredSkills, setRequiredSkills] = useState([]);
//   const organizationId = window.sessionStorage.getItem("organizationId");

//   // const [selectedYear, setSelectedYear] = useState([]);

//   useEffect(() => {
//     getYearsOfExpList();
//     getMonthsOfExpList();
//     getActiveSkills();
//     // getActiveCities();
//     // getSalaryRangeList();
//     // getActiveSkills();
//     // getDesignations();
//     getUgDetails();
//     getPgDetails();
//     fetchAllJobs();
//     fetchActiveJobs();
//   }, []);

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();
//     try {
//       if (!selectedJobID || !selectedJobID.trim()) {
//         console.error("JobID cannot be empty");
//         Toast.error("JobID cannot be empty");
//         return;
//       }
//       if (!candidate_full_name.trim()) {
//         console.error("Candidate name cannot be empty");
//         Toast.error("Candidate name cannot be empty");
//         return;
//       }

//       if (!email_id.trim()) {
//         console.error("Email cannot be empty");
//         Toast.error("Email cannot be empty");
//         return;
//       }

//       if (requiredSkills.length === 0) { // Check if requiredSkills array is empty
//         console.error("Skills cannot be empty");
//         Toast.error("Skills cannot be empty");
//         return;
//       }
//       if (!selectedYear.trim()) {
//         console.error("Experience of years cannot be empty");
//         Toast.error("Experience of years cannot be empty");
//         return;
//       }
//       if (!selectedMonth.trim()) {
//         console.error("Experience of months cannot be empty");
//         Toast.error("Experience of months cannot be empty");
//         return;
//       }
//       if (!resume) {
//         console.error("Resume cannot be empty");
//         Toast.error("Resume cannot be empty");
//         return;
//       }
//       // const skillsString = skills.join(", "); // Join array into a string
//       console.log("Data is added", candidate_full_name, email_id, requiredSkills, selectedYear, selectedMonth, resume, educationDetails
//       );

//       // Prepare form data for submission
//       const formData = new FormData();
//       formData.append("organization_id",organizationId)
//       formData.append("job_id",selectedJobID)
//       formData.append("candidate_full_name", candidate_full_name);
//       formData.append("email_id", email_id);
//       formData.append("skills", requiredSkills); // Convert skills array to JSON string
//       formData.append("experience_years", selectedYear);
//       formData.append("experience_months", selectedMonth);
//       formData.append("upload_resume", resume); // Append the resume file
//       formData.append("educational_qualification", educationDetails); 
      

//        // Log form data
//        const formDataObject = {};
//        formData.forEach((value, key) => {
//            formDataObject[key] = value;
//        });

//       const response = await aiDishaApi.post("/add-candidate/", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data", // Set the content type for file upload
//         }
        
//       });
//       console.log("Response:", response);
//       if (response.status === 200) {
//         Toast.success("Added successfully");
//         handleClear();
//     } 
// } catch (error) {
//     console.error("Error:", error);
//     if (error.response) {
//       console.error("Response data:", error.response.data);
//       Toast.error(error.response.data.detail || "An unexpected error occurred");
//     } else {
//       Toast.error("An unexpected error occurred");
//     }
// }
//   };

//    // To get all 'active' skills from Skill table
//    const getActiveSkills = async () => {
//     await aiDishaApi.get('/skills-show/active')
//     .then((response)=>{
//       const skillData = response.data;
//       setActiveSkills(skillData);
//       console.log("checking skills values :",skillData);          
//       const skillNames = skillData.map(skill => skill.skill_name);
//       console.log("All Skill Names:", skillNames);
//     })
//     .catch((error)=>{
//       console.error("Error fetching active skills"+error);
//     })
//   }

//   const fetchAllJobs = async () => {
//     try {
//       const response = await aiDishaApi.get(`/all_active_jobs?org_id=${organizationId}`); // Fetch all jobs
//       const jobs = response.data; // Assume response.data is an array of jobs

//       if (Array.isArray(jobs)) {
//         setAllJobs(jobs); // Set all jobs in state
//         console.log("All Jobs: ", jobs);
//       } else {
//         console.warn("Expected an array but received: ", jobs);
//         setAllJobs([]); // Clear the jobs if response is not as expected
//       }
//     } catch (error) {
//       console.error("Error fetching all jobs: ", error);
//       setAllJobs([]); // Clear the jobs in case of error
//     }
//   };


//   const fetchActiveJobs = async (jobID) => {
//     setSelectedJobID(jobID); // Set the selected Job ID

//     try {
//       const response = await aiDishaApi.get(`/get_jobdetail_by_job_id?job_id=${jobID}`);
//       const jobData = response.data; // Assuming response.data contains the job object
//       console.log("gsgfg******" + jobData);
//       if (jobData && jobData.job_title) {
//         setJobTitle(jobData.job_title); // Set the job title for the selected Job ID
//         console.log(`Job Title for ${jobID}: ${jobData.job_title}`);
//       } else {
//         setJobTitle(""); // Clear the job title if no data is found
//         console.warn(`No job found for Job ID: ${jobID}`);
//       }
//     } catch (error) {
//       console.error(`Error fetching data for Job ID: ${jobID}`, error);
//       setJobTitle(""); // Reset the title on error
//     }
//   };

//   // const handleYearsDropdown = (event) => {
//   //   setSelectedYear(event.target.value);
//   // };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0]; // Get the first file
//     if (file) {
//       setResume(file); // Set the resume state to the selected file
//     } else {
//       setResume(null); // Reset if no file is selected
//     }
//   };

//   const handleClear = () => {
//     setSelectedJobDetails('');
//     setCandidate_full_name("");
//     setSelectedJobID("");
//     setEmail_id("");
//     setEduDetails([]); 
//     setJobTitle("");
//     setRequiredSkills([]);
//     setSelectedYear("");
//     setSelectedMonth("");
//   };

//   // const validateEducation = {isOthersUg : false, isOthersPg : false};
//   //   const validateEdu = () => {
//   //     educationDetails.map((edu)=>{
//   //       edu === "Others(b)" ? validateEducation.isOthersUg=true : validateEducation.isOthersUg=false;
//   //       edu === "Others(m)" ? validateEducation.isOthersPg=true : validateEducation.isOthersPg=false;
//   //     }) 
//   //   }

//   const currentDate = moment().format("MM/DD/YYYY");

//   // const skill = [
//   //   "Python",
//   //   "Java",
//   //   "Artificial Intelligence",
//   //   "Data Science",
//   //   "Automation Testing",
//   //   "Devops",
//   //   "React JS",
//   //   "Node JS",
//   //   "Scripiting languages",
//   //   "Linux",
//   // ];

//   const getYearsOfExpList = async () => {
//     setYearsOfExpList(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
//       "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40"
//     ]);
//     // await aiDishaApi.get('states/active')
//     //   .then((response)=>{
//     //     setYearsOfExpList(response.data);
//     //   console.log(response.data);
//     //   })
//     //   .catch((error)=> {
//     //   console.error("Error fetching years of experience list", error);
//     //   })
//   }
//   const getMonthsOfExpList = async () => {
//     setMonthsOfExpList(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
//     // await aiDishaApi.get('states/active')
//     //   .then((response)=>{
//     //     setYearsOfExpList(response.data);
//     //   console.log(response.data);
//     //   })
//     //   .catch((error)=> {
//     //   console.error("Error fetching years of experience list", error);
//     //   })
//   }

//   const getUgDetails = async () => {
//     // setEducationDetailsUg(["B.E. Computer Science", "B.Sc.Computer Science", "B.E.
//     //Information Technology","Others(b)"]);
//     await aiDishaApi.get('/undergraduate_degrees')
//       .then((response) => {
//         setEducationDetailsUg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching UG details" + error);
//       })

//   }

//   const getPgDetails = async () => {
//     //setEducationDetailsPg(["M.E. Computer Science", "M.Sc.Computer Science", "M.E.
//     //Information Technology","Others(m)"]);
//     await aiDishaApi.get('/postgraduate_degrees')
//       .then((response) => {
//         setEducationDetailsPg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching PG details" + error);
//       })
//   }


//   const validateEdu = (event) => {

//   }

//   const setEduDetails = (event) => {
//     console.log(event);
//     setEducationDetails(event);
//     //validateEdu(event);

//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersUg((event[i] == "Others(UG)") ? true : false);
//       if (isOthersUg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersUg((event[i] == "Others(UG)") ? true : false);
//       if (isOthersUg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersPg((event[i] == "Others(PG)") ? true : false);
//       if (isOthersPg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersPg((event[i] == "Others(PG)") ? true : false);
//       if (isOthersPg) {
//         break;
//       }
//     }
//     console.log("UG others ? " + isOthersUg);
//     console.log("PG others ? " + isOthersPg);

//   }

//   const CssTextField = styled(TextField)({
//     '& label.Mui-focused': {
//       color: 'black',
//     },
//     '& label': {
//       color: 'black',
//     },
//     '& .MuiInput-underline:after': {
//       borderBottomColor: '#B9B9B9',
//     },
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': {
//         borderColor: '#B9B9B9',
//         borderRadius: 10,

//       },
//       '&:hover fieldset': {
//         borderColor: '#B9B9B9',
//       },
//       '&.Mui-focused fieldset': {
//         borderColor: '#B9B9B9',
//       },
//       '& .MuiInputBase-input': { // Add this line
//         color: 'black', // Change the color here
//       },
//     },
//   });

//   const CssFormControl = styled(FormControl)({
//     '& label': {
//       color: 'black',
//       '&.Mui-focused': {
//         color: 'black',
//       },
//     },
//     '& .MuiInputBase-root': {
//       color: 'black',
//       '& .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#B9B9B9',
//         borderRadius: 10,

//       },
//       '&:hover .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#B9B9B9',
//       },
//       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#B9B9B9',
//       },
//     },
//   });

//   const CssSelect = styled(Select)({
//     '& .MuiSvgIcon-root': {
//       color: 'black',
//       textAlign: "center"
//       // width: "100%
//     },
//   });

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin", // For Firefox
//         msOverflowStyle: "none", // For Internet Explorer
//         scrollbarColor: "transparent transparent", // For Firefox
//         "&::-webkit-scrollbar": {
//           width: "5px", // Width of the scrollbar
//           height: "5px", // Height of the scrollbar
//         },
//       }}>
//       <form onSubmit={handleFormSubmit}>
//         <Box
//           display="grid"
//           gridTemplateColumns="repeat(12, 1fr)"
//           sx={{
//             marginTop: "auto",
//             alignItems: "center",
//             borderRadius: "10px",
//             padding: "1% 10%",
//           }}
//         >
//           <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}>
//             <Typography
//               sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}>
//               Add Candidate
//             </Typography>
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//             <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//               Job ID<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssTextField
//               select
//               label="Job ID"
//               value={selectedJobID} // Selected Job ID state
//               onChange={(e) => fetchActiveJobs(e.target.value)} // Fetch job details on selection
//               size="small"
//               required
//               disabled={false}
//               sx={{ width: "95%", color:"black" }}
//             >
//               <MenuItem value="" disabled sx={{color:"black",backgroundColor:"#033538"}}>
//                 Select Job ID
//               </MenuItem>
//               {alljobs.map((job) => (
//                 <MenuItem key={job.Job_ID} value={job.Job_ID} sx={{color:"grey", backgroundColor:"#033538"}}>
//                   {job.Job_ID}
//                 </MenuItem>
//               ))}
//             </CssTextField>
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//             <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//               Job Title
//             </Typography>
//             <CssTextField
//               disabled
//               label="Job Title"
//               value={jobTitle} // Dynamically display Job Title
//               size="small"
//               sx={{ width: "95%" }}
//               InputLabelProps={{
//                 style: { color: "white" },
//                 "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
//                 {
//                   borderColor: "grey",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#B9B9B9",
//                   borderRadius: "10px",
//                   color: "#B9B9B9"
//                 },
//               }}
//             />
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} >
//             <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//               Candidate_fullname<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <TextField
//               size="small"
//               id="custom-css-outlined-input"
//               label="candidate_full_name"
//               variant="outlined"
//               value={candidate_full_name}
//               onChange={(e) => setCandidate_full_name(e.target.value)}
//               sx={{
//                 width: "95%",
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#B9B9B9",
//                   borderRadius: "10px",
//                 },
//                 "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
//                 {
//                   borderColor: "grey",
//                   color: "white"
//                 },
//                 "& .MuiInputLabel-root": {
//                   color: "white", // Change label color to white
//                 },
//                 "& .MuiInputLabel-root.Mui-focused": {
//                   color: "white", // Change label color when focused
//                 },
//               }}
//               required
//             />
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} >
//             <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//               Email<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <TextField
//               size="small"
//               id="custom-css-outlined-input"
//               label="Email_id"
//               variant="outlined"
//               value={email_id}
//               onChange={(e) => setEmail_id(e.target.value)}
//               sx={{
//                 width: "95%",
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#B9B9B9",
//                   borderRadius: "10px",
//                 },
//                 "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
//                 {
//                   borderColor: "grey",
//                 },
//                 "& .MuiInputLabel-root": {
//                   color: "white", // Change label color to white
//                 },
//                 "& .MuiInputLabel-root.Mui-focused": {
//                   color: "white", // Change label color when focused
//                 },
//               }}
//               required
//             />
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
//             Skills
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Skills</InputLabel>
//             <CssSelect
//               multiple
//               label="Select skills"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: '100%', textAlign: "center", mb: "2%" }}
//               value={requiredSkills}
//               onChange={(e)=>setRequiredSkills(e.target.value)}
//             >
//               {(ActiveSkills || []).map((skill)=>(
//                   <MenuItem 
//                   key={skill.skill_id} 
//                   value={skill.skill_name.trim()} 
//                   sx={{color:"grey",backgroundColor:"#033538"}}>
//                     {skill.skill_name.trim()} 
//                     </MenuItem>
//                 ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//             <Typography sx={{ fontFamily: 'poppins', color: '#033538', textAlign: 'left' }}>
//               Experience(in Years)<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssFormControl sx={{ width: "40%" }}>
//               <InputLabel>Select Years</InputLabel>
//               <CssSelect
//                 label="Experience"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//                 sx={{ width: '100%', textAlign: "center" }}
//                 required={true}
//                 disabled={false}>

//                 {yearsOfExpList.map((exp) => (
//                   <MenuItem key={exp} value={exp} sx={{color:"grey",backgroundColor:"#033538"}}>{exp}</MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//             <CssFormControl sx={{ width: "40%", ml: "5%" }}>
//               <InputLabel>Select Months</InputLabel>
//               <CssSelect
//                 label="Experience"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//                 sx={{ width: '100%', textAlign: "center" }}
//                 required={true}
//                 disabled={false}>

//                 {monthsOfExpList.map((exp) => (
//                   <MenuItem key={exp} value={exp} sx={{color:"grey",backgroundColor:"#033538"}}>{exp}</MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//             <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
//               Education<span style={{ color: "red" }}>*</span></Typography>
//             <CssFormControl sx={{ width: "90%" }}>
//               <InputLabel>Select Education Details</InputLabel>
//               <CssSelect
//                 multiple={true}
//                 label="Select education details"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 required
//                 sx={{ width: '100%', textAlign: "center", mb: "2%" }}
//                 value={educationDetails}
//                 onChange={(e) => setEduDetails(e.target.value)}
//               >
//                 <MenuItem key="ug" value="ug" disabled={true} sx={{ color: '#B9B9B9', backgroundColor: "black" }}>
//                   Under Graduate</MenuItem>
//                 {educationDetailsUg.map((degreeUg) => (
//                   <MenuItem key={degreeUg} value={degreeUg} sx={{color:"grey",backgroundColor:"#033538"}}>{degreeUg}</MenuItem>
//                 ))}
//                 <MenuItem key="pg" value="pg" disabled={true} sx={{ color: '#B9B9B9', backgroundColor: "black" }}>Post Graduate</MenuItem>
//                 {educationDetailsPg.map((degreePg) => (
//                   <MenuItem key={degreePg} value={degreePg} sx={{color:"grey",backgroundColor:"#033538"}}>{degreePg}</MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} display={isOthersUg == true ? 'block' : 'none'}>
//             <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
//               Educational Details (UG)</Typography>
//             <CssTextField label="Enter UG Educational Details" id="custom-css-outlined-input" size="small"
//               sx={{ width: "90%", mb: "2%" }}
//               value={ugDegree}
//               onChange={(e) => setUgDegree(e.target.value)} />
//           </Box>
//           <br />
//           {/* <br/> */}

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} display={isOthersPg == true ? 'block' : 'none'}>
//             <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
//               Educational Details (PG)</Typography>
//             <CssTextField label="Enter PG Educational Details" id="custom-css-outlined-input" size="small"
//               sx={{ width: "90%", mb: "2%" }}
//               value={pgDegree}
//               onChange={(e) => setPgDegree(e.target.value)} />
//           </Box>

//           <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
//             <label htmlFor="formFile" className="form-label" style={{color:"#033538"}}>
//               Upload Resume<span style={{ color: "red" }}>*</span>
//             </label>
//             <input
//               className="form-control"
//               type="file"
//               id="formFile"
//               style={{ width: "95%" }}
//               accept=".pdf,.doc,.docx"
//               onChange={(e) => handleFileChange(e)} // Add your file handling function here
//               required
//             />
//           </Box>

//           <Box gridColumn="span 8" sx={{ marginTop: "8%", ml: "35%", textAlign: "center" }}>
//             <Button
//               onClick={handleClear}
//               sx={{
//                 border: "1px solid",
//                 color: "#033538",
//                 width: "120px",
//                 height: "40px",
//                 borderRadius: "10px",
//                 fontFamily: "poppins",
//               }}
//             >
//               Reset
//             </Button>
//             <Button
//               type="submit"
//               sx={{
//                 ml: "2%",
//                 border: "1px solid",
//                 color: "#033538",
//                 width: "120px",
//                 height: "40px",
//                 borderRadius: "10px",
//                 fontFamily: "poppins",
//               }}
//             >
//               Submit
//             </Button>
//           </Box>
//         </Box>
//       </form>

//     </div>
//   );
// };
// export default AddNewCandidate;














import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Fab, TablePagination } from "@mui/material";
// import TextField from "@mui/material/TextField";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from "@mui/material/FormControl";
// import Checkbox from '@mui/material/Checkbox';
import moment from "moment";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { InputAdornment, IconButton } from '@mui/material';
// import { Typography, Stack } from '@mui/material';
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { Box, Typography, Autocomplete, TextField, Chip } from '@mui/material';
import "./index.css";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const AddNewCandidate = () => {
  const [name, setName] = useState("");
  const [selectedJobID, setSelectedJobID] = useState("");
  const [selectedJobDetails, setSelectedJobDetails] = useState({});
  const [selectedSkills, setSelectedSkills] = useState([]);
  const aiDishaApi = createInstance("DISHA");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [educationDetails, setEducationDetails] = useState([]);
  const [educationDetailsUg, setEducationDetailsUg] = useState([]);
  const [educationDetailsPg, setEducationDetailsPg] = useState([]);
  const [yearsOfExpList, setYearsOfExpList] = useState([]);
  const [monthsOfExpList, setMonthsOfExpList] = useState([]);
  const [expYearsList, setExpYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [candidate_full_name, setCandidate_full_name] = useState();
  const [email_id, setEmail_id] = useState("");
  const [skills, setSkills] = useState("");
  const [loading, setLoading] = useState("");
  const [ugDegree, setUgDegree] = useState("");
  const [pgDegree, setPgDegree] = useState("");
  const [isOthersUg, setIsOthersUg] = useState(false);
  const [isOthersPg, setIsOthersPg] = useState(false);
  const [jobIDs, setJobIDs] = useState([]);
  const [alljobs, setAllJobs] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [jobDescription, setJobDescription] = useState(""); // Added job description state
  const [years, setYears] = useState([]);
  const [resume, setResume] = useState(null);
  const [error, setError] = useState('');
  const [ActiveSkills, setActiveSkills] = useState([]);
  const [requiredSkills, setRequiredSkills] = useState([]);
  const organizationId = window.sessionStorage.getItem("organizationId");

  useEffect(() => {
    getYearsOfExpList();
    getMonthsOfExpList();
    getActiveSkills();
    getUgDetails();
    getPgDetails();
    fetchAllJobs();
    fetchActiveJobs();
  }, []);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!selectedJobID || !selectedJobID.trim()) {
        console.error("JobID cannot be empty");
        Toast.error("JobID cannot be empty");
        return;
      }
      if (!candidate_full_name.trim()) {
        console.error("Candidate name cannot be empty");
        Toast.error("Candidate name cannot be empty");
        return;
      }

      if (!email_id.trim()) {
        console.error("Email cannot be empty");
        Toast.error("Email cannot be empty");
        return;
      }

      if (requiredSkills.length === 0) {
        console.error("Skills cannot be empty");
        Toast.error("Skills cannot be empty");
        return;
      }
      if (!selectedYear.trim()) {
        console.error("Experience of years cannot be empty");
        Toast.error("Experience of years cannot be empty");
        return;
      }
      if (!selectedMonth.trim()) {
        console.error("Experience of months cannot be empty");
        Toast.error("Experience of months cannot be empty");
        return;
      }
      if (!resume) {
        console.error("Resume cannot be empty");
        Toast.error("Resume cannot be empty");
        return;
      }

      console.log("Data is added", candidate_full_name, email_id, requiredSkills, selectedYear, selectedMonth, resume, educationDetails);

      // Prepare form data for submission
      const formData = new FormData();
      formData.append("organization_id", organizationId);
      formData.append("job_id", selectedJobID);
      formData.append("candidate_full_name", candidate_full_name);
      formData.append("email_id", email_id);
      formData.append("skills", requiredSkills);
      formData.append("experience_years", selectedYear);
      formData.append("experience_months", selectedMonth);
      formData.append("upload_resume", resume);
      formData.append("educational_qualification", educationDetails);
      formData.append("job_description", jobDescription);

      // Log form data
      const formDataObject = {};
      formData.forEach((value, key) => {
        setLoading(true);
        formDataObject[key] = value;
      });

      const response = await aiDishaApi.post("/add-candidate/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });
      
      console.log("Response:", response);
      if (response.status === 200) {
        Toast.success("Added successfully");
        handleClear();
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        Toast.error(error.response.data.detail || "An unexpected error occurred");
      } else {
        Toast.error("An unexpected error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  // To get all 'active' skills from Skill table
  const getActiveSkills = async () => {
    await aiDishaApi.get('/skills-show/active')
      .then((response) => {
        const skillData = response.data;
        setActiveSkills(skillData);
        console.log("checking skills values :", skillData);
        const skillNames = skillData.map(skill => skill.skill_name);
        console.log("All Skill Names:", skillNames);
      })
      .catch((error) => {
        console.error("Error fetching active skills" + error);
      })
  }

  const fetchAllJobs = async () => {
    try {
      const response = await aiDishaApi.get(`/all_active_jobs?org_id=${organizationId}`);
      const jobs = response.data;

      if (Array.isArray(jobs)) {
        setAllJobs(jobs);
        console.log("All Jobs: ", jobs);
      } else {
        console.warn("Expected an array but received: ", jobs);
        setAllJobs([]);
      }
    } catch (error) {
      console.error("Error fetching all jobs: ", error);
      setAllJobs([]);
    }
  };

  const fetchActiveJobs = async (jobID) => {
    setSelectedJobID(jobID);

    try {
      const response = await aiDishaApi.get(`/get_jobdetail_by_job_id?job_id=${jobID}`);
      const jobData = response.data;
      console.log("Job data fetched:", jobData);
      
      if (jobData) {
        // Set job title
        if (jobData.job_title) {
          setJobTitle(jobData.job_title);
          console.log(`Job Title for ${jobID}: ${jobData.job_title}`);
        } else {
          setJobTitle("");
          console.warn(`No job title found for Job ID: ${jobID}`);
        }
        
        // Set job description
        if (jobData.job_description) {
          setJobDescription(jobData.job_description);
          console.log(`Job Description for ${jobID}: ${jobData.job_description}`);
        } else {
          setJobDescription("");
          console.warn(`No job description found for Job ID: ${jobID}`);
        }
      } else {
        setJobTitle("");
        setJobDescription("");
        console.warn(`No job found for Job ID: ${jobID}`);
      }
    } catch (error) {
      console.error(`Error fetching data for Job ID: ${jobID}`, error);
      setJobTitle("");
      setJobDescription("");
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setResume(file);
    } else {
      setResume(null);
    }
  };

  const handleClear = () => {
    setSelectedJobDetails('');
    setCandidate_full_name("");
    setSelectedJobID("");
    setEmail_id("");
    setEduDetails([]);
    setJobTitle("");
    setJobDescription(""); // Clear job description
    setRequiredSkills([]);
    setSelectedYear("");
    setSelectedMonth("");
  };

  const currentDate = moment().format("MM/DD/YYYY");

  const getYearsOfExpList = async () => {
    setYearsOfExpList(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
      "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40"
    ]);
  }

  const getMonthsOfExpList = async () => {
    setMonthsOfExpList(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
  }

  const getUgDetails = async () => {
    await aiDishaApi.get('/undergraduate_degrees')
      .then((response) => {
        setEducationDetailsUg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching UG details" + error);
      })
  }

  const getPgDetails = async () => {
    await aiDishaApi.get('/postgraduate_degrees')
      .then((response) => {
        setEducationDetailsPg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PG details" + error);
      })
  }

  const validateEdu = (event) => {

  }

  const setEduDetails = (event) => {
    console.log(event);
    setEducationDetails(event);

    for (var i = 0; i < event?.length; i++) {
      setIsOthersUg((event[i] == "Others(UG)") ? true : false);
      if (isOthersUg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersUg((event[i] == "Others(UG)") ? true : false);
      if (isOthersUg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersPg((event[i] == "Others(PG)") ? true : false);
      if (isOthersPg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersPg((event[i] == "Others(PG)") ? true : false);
      if (isOthersPg) {
        break;
      }
    }
    console.log("UG others ? " + isOthersUg);
    console.log("PG others ? " + isOthersPg);
  }

  const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: 'black',
    },
    '& label': {
      color: 'black',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#B9B9B9',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#B9B9B9',
        borderRadius: 10,
      },
      '&:hover fieldset': {
        borderColor: '#B9B9B9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#B9B9B9',
      },
      '& .MuiInputBase-input': {
        color: 'black',
      },
    },
  });

  const CssFormControl = styled(FormControl)({
    '& label': {
      color: 'black',
      '&.Mui-focused': {
        color: 'black',
      },
    },
    '& .MuiInputBase-root': {
      color: 'black',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B9B9B9',
        borderRadius: 10,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B9B9B9',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B9B9B9',
      },
    },
  });

  const CssSelect = styled(Select)({
    '& .MuiSvgIcon-root': {
      color: 'black',
      textAlign: "center"
    },
  });

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        scrollbarColor: "transparent transparent",
        "&::-webkit-scrollbar": {
          width: "5px",
          height: "5px",
        },
      }}>
      <form onSubmit={handleFormSubmit}>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "auto",
            alignItems: "center",
            borderRadius: "10px",
            padding: "1% 10%",
          }}
        >
          <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}>
              Add Candidate
            </Typography>
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
              Job ID<span style={{ color: "red" }}>*</span>
            </Typography>
            <CssTextField
              select
              label="Job ID"
              value={selectedJobID}
              onChange={(e) => fetchActiveJobs(e.target.value)}
              size="small"
              required
              disabled={false}
              sx={{ width: "95%", color: "black" }}
            >
              <MenuItem value="" disabled sx={{ color: "black", backgroundColor: "#033538" }}>
                Select Job ID
              </MenuItem>
              {alljobs.map((job) => (
                <MenuItem key={job.Job_ID} value={job.Job_ID} sx={{ color: "grey", backgroundColor: "#033538" }}>
                  {job.Job_ID}
                </MenuItem>
              ))}
            </CssTextField>
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
              Job Title
            </Typography>
            <CssTextField
              disabled
              label="Job Title"
              value={jobTitle}
              size="small"
              sx={{ width: "95%" }}
              InputLabelProps={{
                style: { color: "white" },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "grey",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9B9B9",
                  borderRadius: "10px",
                  color: "#B9B9B9"
                },
              }}
            />
          </Box>

          {/* New Job Description Field */}
          <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
              Job Description
            </Typography>
            <CssTextField
              disabled
              label="Job Description"
              value={jobDescription}
              size="small"
              multiline
              rows={4}
              sx={{ width: "97.5%" }}
              InputLabelProps={{
                style: { color: "white" },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "grey",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9B9B9",
                  borderRadius: "10px",
                  color: "#B9B9B9"
                },
              }}
            />
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} >
            <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
              Candidate_fullname<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              size="small"
              id="custom-css-outlined-input"
              label="candidate_full_name"
              variant="outlined"
              value={candidate_full_name}
              onChange={(e) => setCandidate_full_name(e.target.value)}
              sx={{
                width: "95%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9B9B9",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "grey",
                  color: "white"
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white",
                },
              }}
              required
            />
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} >
            <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
              Email<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              size="small"
              id="custom-css-outlined-input"
              label="Email_id"
              variant="outlined"
              value={email_id}
              onChange={(e) => setEmail_id(e.target.value)}
              sx={{
                width: "95%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9B9B9",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "grey",
                },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white",
                },
              }}
              required
            />
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
              Skills
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <CssFormControl sx={{ width: "90%" }}>
              <InputLabel>Select Skills</InputLabel>
              <CssSelect
                multiple
                label="Select skills"
                id="demo-simple-select-outlined"
                size="small"
                sx={{ width: '100%', textAlign: "center", mb: "2%" }}
                value={requiredSkills}
                onChange={(e) => setRequiredSkills(e.target.value)}
              >
                {(ActiveSkills || []).map((skill) => (
                  <MenuItem
                    key={skill.skill_id}
                    value={skill.skill_name.trim()}
                    sx={{ color: "grey", backgroundColor: "#033538" }}>
                    {skill.skill_name.trim()}
                  </MenuItem>
                ))}
              </CssSelect>
            </CssFormControl>
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: 'poppins', color: '#033538', textAlign: 'left' }}>
              Experience(in Years)<span style={{ color: "red" }}>*</span>
            </Typography>
            <CssFormControl sx={{ width: "40%" }}>
              <InputLabel>Select Years</InputLabel>
              <CssSelect
                label="Experience"
                id="demo-simple-select-outlined"
                size="small"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                sx={{ width: '100%', textAlign: "center" }}
                required={true}
                disabled={false}>

                {yearsOfExpList.map((exp) => (
                  <MenuItem key={exp} value={exp} sx={{ color: "grey", backgroundColor: "#033538" }}>{exp}</MenuItem>
                ))}
              </CssSelect>
            </CssFormControl>
            <CssFormControl sx={{ width: "40%", ml: "5%" }}>
              <InputLabel>Select Months</InputLabel>
              <CssSelect
                label="Experience"
                id="demo-simple-select-outlined"
                size="small"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                sx={{ width: '100%', textAlign: "center" }}
                required={true}
                disabled={false}>

                {monthsOfExpList.map((exp) => (
                  <MenuItem key={exp} value={exp} sx={{ color: "grey", backgroundColor: "#033538" }}>{exp}</MenuItem>
                ))}
              </CssSelect>
            </CssFormControl>
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
              Education<span style={{ color: "red" }}>*</span></Typography>
            <CssFormControl sx={{ width: "90%" }}>
              <InputLabel>Select Education Details</InputLabel>
              <CssSelect
                multiple={true}
                label="Select education details"
                id="demo-simple-select-outlined"
                size="small"
                required
                sx={{ width: '100%', textAlign: "center", mb: "2%" }}
                value={educationDetails}
                onChange={(e) => setEduDetails(e.target.value)}
              >
                <MenuItem key="ug" value="ug" disabled={true} sx={{ color: '#B9B9B9', backgroundColor: "black" }}>
                  Under Graduate</MenuItem>
                {educationDetailsUg.map((degreeUg) => (
                  <MenuItem key={degreeUg} value={degreeUg} sx={{ color: "grey", backgroundColor: "#033538" }}>{degreeUg}</MenuItem>
                ))}
                <MenuItem key="pg" value="pg" disabled={true} sx={{ color: '#B9B9B9', backgroundColor: "black" }}>Post Graduate</MenuItem>
                {educationDetailsPg.map((degreePg) => (
                  <MenuItem key={degreePg} value={degreePg} sx={{ color: "grey", backgroundColor: "#033538" }}>{degreePg}</MenuItem>
                ))}
              </CssSelect>
            </CssFormControl>
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} display={isOthersUg == true ? 'block' : 'none'}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
              Educational Details (UG)</Typography>
            <CssTextField label="Enter UG Educational Details" id="custom-css-outlined-input" size="small"
              sx={{ width: "90%", mb: "2%" }}
              value={ugDegree}
              onChange={(e) => setUgDegree(e.target.value)} />
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }} display={isOthersPg == true ? 'block' : 'none'}>
            <Typography sx={{ fontFamily: "poppins", color: "#033538", textAlign: 'left' }}>
              Educational Details (PG)</Typography>
            <CssTextField label="Enter PG Educational Details" id="custom-css-outlined-input" size="small"
              sx={{ width: "90%", mb: "2%" }}
              value={pgDegree}
              onChange={(e) => setPgDegree(e.target.value)} />
          </Box>

          <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}>
            <label htmlFor="formFile" className="form-label" style={{ color: "#033538" }}>
              Upload Resume<span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="form-control"
              type="file"
              id="formFile"
              style={{ width: "95%" }}
              accept=".pdf,.doc,.docx"
              onChange={(e) => handleFileChange(e)}
              required
            />
          </Box>

          <Box gridColumn="span 8" sx={{ marginTop: "8%", ml: "35%", textAlign: "center" }}>
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: "#033538",
                width: "120px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Reset
            </Button>
            <Button
              type="submit"
              variant="contained" 
              disabled={loading} 
              sx={{
                ml: "2%",
                border: "1px solid",
                color: "#033538",
                width: "120px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
             {loading ? "Submitting..." : "Submit"}            </Button>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default AddNewCandidate;